export enum DefaultType {
  GeneralFreight = 0,
  Jobbing = 1,
  ContainerJob = 2
}
